module.exports = __webpack_public_path__ + "assets/img/help_pagination01-3.d19df5dc.svg";